// src/components/ModalNota.jsx
import React, { useCallback, useState } from "react";
import { FaTimes } from "react-icons/fa";
import Listagem from "./Listagem";
import AtaCard from "./AtaCard";
import Task from "./Task";
import Metas from "./Meta";
import Rdo from "./Rdo";
import "./Cards.css";

const TIPOS_NOTA_CRIACAO = [
  { key: "Atas",        label: "Atas" },
  { key: "Lista",       label: "Listagem" },
  { key: "Metas",       label: "Metas" },
  { key: "Nota Rápida", label: "Nota Rápida" },
  { key: "Tarefas",     label: "Tarefas" },
];

const CORES_TIPO = {
  "Atas":        "#10b981",
  "Lista":       "#3b82f6",
  "Metas":       "#06b6d4",
  "Nota Rápida": "#ec4899",
  "Tarefas":     "#fbbf24",
};

const TIPO_ICONE = {
  "Atas":        "description",
  "Lista":       "list",
  "Metas":       "flag",
  "Nota Rápida": "bolt",
  "Tarefas":     "task_alt",
};

export default function ModalNota({
  showNovaNota,
  showEditarNota,
  showVisualizarNota,
  onCloseNovaNota,
  onCloseEditarNota,
  onCloseVisualizarNota,
  formData,
  setFormData,
  handleSaveTask,
  notaEditData,
  setNotaEditData,
  saveEditedNota,
  notaSelecionada,
  project,
  usuarioAtual,
  usuarioId,
  notaProgresso,
  setNotaProgresso,
  donoContainerId,
  onStatusUpdate,
  setColumns,
  setColumnsNormais,
  setColumnsArquivadas,
  onOpenTask,
  onNotaCopiada, 
  inline = false,
  notasDaPilha = [],
  pilhaId = null,
}) {
  const atasDaPilha = notasDaPilha.filter(n => n.tipo === "Atas");
  const indexAtual = atasDaPilha.findIndex(n => n.id === notaSelecionada?.id);

  const rdosDaPilha = notasDaPilha.filter(n => n.tipo === "Diário de Obra");
  const indexAtualRdo = rdosDaPilha.findIndex(n => n.id === notaSelecionada?.id);

  const handleProgressoChange = useCallback(
    (progresso) => {
      if (notaSelecionada?.id) {
        setNotaProgresso((prev) => ({ ...prev, [notaSelecionada.id]: progresso }));
      }
    },
    [notaSelecionada?.id, setNotaProgresso]
  );

  const handleNavegarAta = useCallback((nota) => {
    if (onOpenTask) {
      onCloseVisualizarNota();
      setTimeout(() => {
        onOpenTask(nota.id);
      }, 50);
    }
  }, [onOpenTask, onCloseVisualizarNota]);

  const handleNavegarRdo = useCallback((notaId) => {
    if (onOpenTask) {
      onCloseVisualizarNota();
      setTimeout(() => {
        onOpenTask(notaId);
      }, 50);
    }
  }, [onOpenTask, onCloseVisualizarNota]);

  const handleFieldChange = (field, value) => {
    if (showNovaNota) {
      setFormData((prev) => ({ ...prev, [field]: value }));
    } else {
      setNotaEditData((prev) => ({ ...prev, [field]: value }));
    }
  };

  if (!showNovaNota && !showEditarNota && !showVisualizarNota) return null;

  if (showVisualizarNota && notaSelecionada && notaSelecionada.tipo === "Nota Rápida") return null;

  const tipoAtual   = showNovaNota ? formData.tipo : notaSelecionada?.tipo || notaEditData?.tipo;
  const tituloModal = showNovaNota ? "Nova Nota" : "Editar Nota";

  const modalContent = (
    <>
      {(showNovaNota || showEditarNota) && (
        <div className="nn-container">
          <div className="nn-header">
            <div className="nn-header-icon">
              <span className="material-symbols-outlined">note_add</span>
            </div>
            <div className="nn-header-titles">
              <h2 className="nn-title">{tituloModal}</h2>
              <p className="nn-subtitle">
                {showNovaNota ? "Crie uma nova nota para o projeto." : "Edite os dados da nota."}
              </p>
            </div>
            <button className="nn-close-btn" onClick={showNovaNota ? onCloseNovaNota : onCloseEditarNota}>
              <FaTimes />
            </button>
          </div>

          <div className="nn-divider" />

          <div className="nn-body">
            <div className="nn-field-label">
              <span>Nome da nota</span>
            </div>
            <input
              type="text"
              className="nn-input"
              value={showNovaNota ? formData.nome : notaEditData.nome}
              onChange={(e) => handleFieldChange("nome", e.target.value)}
              placeholder="Digite o nome da nota"
              autoFocus
            />

            {showNovaNota && (
              <>
                <div className="nn-field-label" style={{ marginTop: 24 }}>
                  <span>Tipo de Nota</span>
                </div>
                <p className="nn-field-hint">Selecione o tipo de nota que deseja criar.</p>

                <div className="nn-tipo-list">
                  {TIPOS_NOTA_CRIACAO.map(({ key, label }) => {
                    const isSelected = formData.tipo === key;
                    return (
                      <div
                        key={key}
                        className={`nn-tipo-row${isSelected ? " nn-tipo-row--ativo" : ""}`}
                        onClick={() => setFormData((prev) => ({ ...prev, tipo: key }))}
                        style={{ "--tipo-cor": CORES_TIPO[key] }}
                      >
                        <div className="nn-tipo-icon">
                          <span className="material-symbols-outlined">{TIPO_ICONE[key]}</span>
                        </div>
                        <span className="nn-tipo-label">{label}</span>
                        <span className={`nn-tipo-radio${isSelected ? " nn-tipo-radio--ativo" : ""}`} />
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>

          <div className="nn-divider" />

          <div className="nn-footer">
            <button className="nn-btn-cancelar" onClick={showNovaNota ? onCloseNovaNota : onCloseEditarNota}>
              Cancelar
            </button>
            <button className="nn-btn-criar" onClick={showNovaNota ? handleSaveTask : saveEditedNota}>
              <span className="material-symbols-outlined" style={{ fontSize: 18 }}>add_circle</span>
              {showNovaNota ? "Criar" : "Salvar"}
            </button>
          </div>
        </div>
      )}

      {showVisualizarNota && notaSelecionada && (
        <>
          {(() => {
            const tipo = notaSelecionada.tipo;

            switch (tipo) {
              case "Atas":
                return (
                  <AtaCard
                    projetoAtual={project}
                    notaAtual={notaSelecionada}
                    onProgressoChange={handleProgressoChange}
                    user={{ id: usuarioId }}
                    onClose={onCloseVisualizarNota}
                    containerAtual={{ id: donoContainerId }}
                    onOpenTask={onOpenTask}
                    atasDaPilha={atasDaPilha}
                    indexAtual={indexAtual}
                    onNavegarAta={handleNavegarAta}
                  />
                );

              case "Tarefas":
                return (
                  <Task
                    projetoAtual={project}
                    notaAtual={notaSelecionada}
                    pilhaAtual={notaSelecionada.pilha_id ? { id: notaSelecionada.pilha_id } : null}
                    usuarioAtual={usuarioAtual}
                    onClose={onCloseVisualizarNota}
                    containerAtual={{ id: donoContainerId }}
                    setColumns={setColumns}
                    setColumnsNormais={setColumnsNormais}
                    setColumnsArquivadas={setColumnsArquivadas}
                  />
                );

              case "Metas":
                return (
                  <Metas
                    notaId={notaSelecionada.id}
                    projectId={project?.type === "project" ? project.id : null}
                    setorId={project?.type === "setor" ? project.id : null}
                    entityType={project?.type}
                    usuarioId={usuarioId}
                    projetoNome={project?.name || "Projeto"}
                    notaNome={notaSelecionada?.nome || "Metas"}
                    onClose={onCloseVisualizarNota}
                    containerAtual={{ id: donoContainerId }}
                    onOpenTask={onOpenTask}
                    onNotaCopiada={onNotaCopiada} 
                  />
                );

              case "Diário de Obra":
                return (
                  <Rdo
                    notaId={notaSelecionada.id}
                    onClose={onCloseVisualizarNota}
                    usuarioId={usuarioId}
                    projetoAtual={project}
                    rdosDaPilha={rdosDaPilha}
                    indexAtual={indexAtualRdo}
                    onNavegarRdo={handleNavegarRdo}
                    pilhaId={pilhaId}
                  />
                );

              default:
                return (
                  <Listagem
                    projetoAtual={project}
                    notaAtual={notaSelecionada}
                    containerAtual={{ id: donoContainerId }}
                    usuarioAtual={usuarioAtual}
                    onClose={onCloseVisualizarNota}
                    onStatusUpdate={onStatusUpdate}
                  />
                );
            }
          })()}
        </>
      )}
    </>
  );

  if (inline) {
    return (
      <div className={`modal-content ${showVisualizarNota ? "large" : ""}`}>
        {modalContent}
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className={`modal-content ${showVisualizarNota ? "large" : ""}`}>
        {modalContent}
      </div>
    </div>
  );
}